import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { LoaderComponent } from '../../servicios/loader/loader.component';
import { SeleccionService } from '../../servicios/seleccion.service';
import { ToolsService } from '../../recursos/tools.service';
import { IngresoService } from '../../servicios/ingreso.service';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { Router } from '@angular/router';
import { configuracion } from '../../recursos/config.service';
import { recursosCompartido } from 'src/app/recursos/cosumoGeneral.service';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { EstudioSocioEconomicoComponent } from '../estudio-socio-economico/estudio-socio-economico.component';
import { toString } from '@ng-bootstrap/ng-bootstrap/util/util';

@Component({
  selector: 'app-req-especifico-operario-ver',
  templateUrl: './req-especifico-operario-ver.component.html',
  styleUrls: ['./req-especifico-operario-ver.component.css']
})
export class ReqEspecificoOperarioVerComponent implements OnInit {

  public mr: NgbModalRef;
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptionsGen: DataTables.Settings = {};
  dtOptionsEsp: DataTables.Settings = {};
  public dtTriggerGen: Subject<any>;
  public dtTriggerEsp: Subject<any>;

  public nombreBeca: string = ""; private accion: number = 0; public tituloModal: string = ""; public editaObservacion = 'true';
  public opcionObs: boolean = false; private vecPostulaReq: Array<any> = []; private vecAjusteBeca: Array<any> = [];
  public vecReqGeneral: Array<any>; public vecReqEspecifico: Array<any>; private datoPerfil: any;
  private correoPostula: string = ''; private tokenDrive: any;
  public rutaCarga: SafeResourceUrl | undefined; public enlaceCarga: string = '';

  constructor(private cargando: LoaderComponent, private srvSelect: SeleccionService, private tools: ToolsService, private confMensaje: configuracion,
    private sanitizer: DomSanitizer, private modalService: NgbModal, private srvInsert: IngresoService, private alerti: AlertifyService, private ruta: Router,
    private srvGeneral: recursosCompartido) { }

  async ngOnInit() {
    this.nombreBeca = localStorage.getItem('modNom');

    this.dtTriggerGen = new Subject<any>();
    this.dtTriggerEsp = new Subject<any>();
    this.dtOptionsGen[0] = this.tools.OpcionesTabla(10);
    this.dtOptionsEsp[0] = this.tools.OpcionesTabla(10);

    this.datoPerfil = await this.srvGeneral.genObtenerCargoTTHH(localStorage.getItem('ciUsuario'));
    console.log("::::::::::::::::::this.datoPerfil: ", this.datoPerfil);
    await this.datosCentral();
    this.cargarPostulacion();

    this.tokenDrive = await this.srvGeneral.getTokenLocal();
    this.editaObservacion = localStorage.getItem('editaPost')
  }
  //FUNCION QUE CARGA LOS PDF
  async verArchivoCarga(nombModal: any, rutaArchivo: any) {
    this.cargando.abrir();
    if (rutaArchivo.fuente != 3) {
      this.rutaCarga = ''; this.enlaceCarga = '';
      this.rutaCarga = await this.srvGeneral.obtenerArchivoPDF(this.tokenDrive, rutaArchivo.documento);
      this.enlaceCarga = await this.srvGeneral.obtenerRutaPDF(this.tokenDrive, rutaArchivo.documento);
      this.mr = this.modalService.open(nombModal, 
        {
            size: 'xl' as any
        });
    }
    else {
      this.rutaCarga = await this.sanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + rutaArchivo.documento);
      this.mr = this.modalService.open(nombModal);
    }
    this.cargando.cerrar();
  }
  //OBTIENE LOS DATOS DE LA CENTRALIZADA DADO LA CEDULA
  async datosCentral() {
    this.srvSelect.personaCentralDocumento(localStorage.getItem('localCedula')).subscribe(data => {
      if (data.success)
        this.correoPostula = data.datos['per_email'];//mi correo
      else
        this.correoPostula = '';
    });
  }
  async cargarPostulacion() {
    this.vecReqGeneral = [];
    const resPost = await new Promise<any>(resolve =>
      this.srvSelect.gestionPostulantes(9, localStorage.getItem('localIdPostula'), 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resPost.success) {
      this.cargando.abrir();
      await this.cargarReqEspecificos(resPost.postula[0]);
      await this.cargarReqGenerales(resPost.postula[0]);
      this.vecAjusteBeca = await this.srvGeneral.getGeneralAjustesBeca(14, resPost.postula[0].intTipoBeca, resPost.postula[0].strPeriodo);
      this.cargando.cerrar();
    }
  }

  //FUNCION QUE CARGA LOS REQUISITOS ESPECIFICOS QUE APLICA EL POSTULANTE
  async cargarReqEspecificos(objPostula) {
    let rutaArchivo = '';
    //OBTENER EL ESTUDIO SOCIO ECONÓMICO EN CASO DE TENER
    const resEconomico = await new Promise<any>(resolve =>
      this.srvSelect.gestionSocioEconomico(9, objPostula.cedulaEstudiante, objPostula.strPeriodo, 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    //OBTENER EL RECORD ACADEMICO DEL ESTUDIANTE
    const resRecord = await new Promise<any>(resolve =>
      this.srvSelect.gestionRecordAcademico(objPostula.baseCarrera, objPostula.codigoEstudiante, this.datoPerfil[0].estado ? this.datoPerfil[0].nombres : 'Sin Registro',
        this.datoPerfil[0].estado ? this.datoPerfil[0].rol.replace('/A', '(A)') : 'Sin Registro').subscribe(translated => {
          resolve(translated)
        }));
    var table3 = $('#tblEspecifico').DataTable({
      destroy: true
    });
    table3.destroy();

    this.vecReqEspecifico = [];
    const resEsp = await new Promise<any>(resolve =>
      this.srvSelect.gestionRequisitos(1, objPostula.intTipoBeca, objPostula.strPeriodo, 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resEsp.success) {
      for (let objEsp of resEsp.especifico) {
        if (objEsp.reqEstado == 1) {
          const resAplEsp = await new Promise<any>(resolve =>
            this.srvSelect.gestionRequisitos(6, objPostula.intIdAplica, objEsp.intIdRequisito, 'na').subscribe(translated => {
              resolve(translated)
            }));
          this.vecReqEspecifico.push({
            intIdRequisito: objEsp.intIdRequisito, strNombre: objEsp.strNombre, strDescripcion: objEsp.strDescripcion, intEstado: objEsp.intEstado, intTipo: objEsp.intTipo,
            intTipoBeca: objEsp.intTipoBeca, codPeriodo: objEsp.codPeriodo, estado: objEsp.estado, tipoFuente: objEsp.strNombTipo,
            documento: objEsp.intIdFuente == 1 ? resAplEsp.success ? resAplEsp.especifico[0].strDocumento : '' :
              objEsp.intIdFuente == 2 ? resEconomico.resultado ? resEconomico.socioEconomico[0].strRuta : '' : JSON.parse(resRecord._body).success ? JSON.parse(resRecord._body).listado : '',
            estadoCarga: resAplEsp.success ? resAplEsp.especifico[0].intEstado : 0,
            entrega: objEsp.intIdFuente == 1 ? resAplEsp.success ? 1 : 0 : resEconomico.resultado ? 1 : 0, fuente: objEsp.intIdFuente,
            aceptado: resAplEsp.success ? resAplEsp.especifico[0].intAceptado : 0, fechaCarga: resAplEsp.success ? resAplEsp.especifico[0].dtFecha.split('T')[0] : '',
            observacion: resAplEsp.success ? resAplEsp.especifico[0].strObservaciones : '', idAplica: resAplEsp.success ? resAplEsp.especifico[0].intPostula : ''
          });
        }
      }
      this.dtTriggerEsp.next();
    }
  }
  //FUNCION QUE CARGA LOS REQUISITOS GENERALES QUE APLICA EL POSTULANTE
  async cargarReqGenerales(objPostula) {

    const resEconomico = await new Promise<any>(resolve =>
      this.srvSelect.gestionSocioEconomico(9, objPostula.cedulaEstudiante, objPostula.strPeriodo, 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));

    var table2 = $('#tblGeneral').DataTable({
      destroy: true
    });
    table2.destroy();

    this.vecReqGeneral = [];
    const resGen = await new Promise<any>(resolve =>
      this.srvSelect.gestionRequisitos(10, objPostula.intBeca, objPostula.strPeriodo, 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resGen.success) {
      for (let objGen of resGen.especifico) {
        if ((objGen.genEstado == 1) && (objPostula.intBeca == objGen.becaId)) {

          const resAplGen = await new Promise<any>(resolve =>
            this.srvSelect.gestionRequisitos(5, objPostula.intIdAplica, objGen.reqId, 'na').subscribe(translated => {
              resolve(translated)
            }));
          this.vecReqGeneral.push({
            intIdRequisito: objGen.reqId, strNombre: objGen.reqNombre, strDescripcion: objGen.reqDetalle, intEstado: objGen.reqEstado, intTipo: objGen.reqTipo,
            intTipoBeca: objGen.reqTipo, codPeriodo: objGen.genPeriodo, estado: objGen.becaEstado, tipoFuente: objGen.strNombTipo,
            documento: objGen.intIdFuente == 1 ? resAplGen.success ? resAplGen.especifico[0].strDocumento : '' : resEconomico.resultado ? resEconomico.socioEconomico[0].strRuta : '',
            estadoCarga: resAplGen.success ? resAplGen.especifico[0].intEstado : 0, entrega: objGen.intIdFuente == 1 ? resAplGen.success ? 1 : 0 : resEconomico.resultado ? 1 : 0,
            fuente: objGen.intIdFuente,
            aceptado: resAplGen.success ? resAplGen.especifico[0].intAceptado : 0, fechaCarga: resAplGen.success ? resAplGen.especifico[0].dtFecha.split('T')[0] : '',
            observacion: resAplGen.success ? resAplGen.especifico[0].strObservaciones : '', idAplica: resAplGen.success ? resAplGen.especifico[0].intPostula : ''
          });
        }
      }
    }
    this.dtTriggerGen.next();
  }
  //DUNCION QUE ABRE EL MODAL PARA INGRESAR UNA OBSERVACION AL REQUISITO
  modalModRequisito(modal, requisito, tipo) {
    this.tituloModal = requisito.Requisito;
    this.vecPostulaReq = requisito;
    this.accion = tipo;
    this.mr = this.modalService.open(modal);
  }
  //FUNCION QUE CIERRA EL MODAL
  cerrarModal() {
    this.mr.close();
  }
  //MODIFICA LAS OBSERVACIONES REALIZADAS A CADA UNO DE LOS REQUSITOS SUBIDOS POR EL POSTULANTE
  editarRequisito() {
    this.srvInsert.ingresoGestionRequisitos(this.vecPostulaReq['observacion'], this.vecPostulaReq['aceptado'], this.vecPostulaReq['idAplica'], this.vecPostulaReq['intIdRequisito'], "na",
      "na", "na", "na", this.accion == 1 ? 7 : 8).subscribe(res => {
        if (res.requisito) {
          this.cambiaEstadoPostula(this.vecPostulaReq['idAplica'], this.vecPostulaReq['aceptado']);
          this.alerti.success("Observación registrada correctamente");
          this.cerrarModal();
        }
      });
  }
  //CAMBIAR EL ESTADO DE LA POSTULACION DE COMPLETO A INCOMPLETO EN CASO DE HABER OBSERVACIONES
  cambiaEstadoPostula(aplica, estado) {
    if (estado == 2) {
      this.srvInsert.ingresoGestionBecas(aplica, estado, 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 13).subscribe(res => {
        if (!res.becas) {
          this.alerti.error("Error al guardar la observación");
        }
      });
    }
  }
  //ENVIA UN COOREO CON LAS OBSERVACIONES REALIZADAS POR EL ANALISTA.
  async envioObservaciones() {
    const resEsp = await new Promise<any>(resolve =>
      this.srvSelect.gestionRequisitos(7, localStorage.getItem('localIdPostula'), localStorage.getItem('modBeca'), "na").subscribe(translated => {
        resolve(translated)
      }));
    if (resEsp.success)
      this.enviarCorreo(resEsp.especifico);
    else
      this.alerti.warning("No se ha ingresado observaciones al postulante");
  }
  //FUNCION QUE PERMITE EL ENVÍO DE CORREOS
  async enviarCorreo(reqPostula) {
    let tblObserva = ``;
    tblObserva = `</br> <table> <tr>
    <td style='border-bottom: solid 1px #555555; padding: 5px; min-width: 50px; text-align: center; font-weight: bold;'> TIPO REQUISITO </td>
    <td style='border-bottom: solid 1px #555555; padding: 5px; min-width: 80px; text-align: center; font-weight: bold;'> REQUISITO </td>
    <td style='border-bottom: solid 1px #555555; padding: 5px; min-width: 80px; text-align: center; font-weight: bold;'> OBSERVACI&Oacute;N </td> </tr>`;
    for (let i in reqPostula) {
      tblObserva += `<tr> <td style='border-bottom: solid 1px #DDDDDD; padding: 3px;'> ${reqPostula[i]['tipoReq']} </td>
      <td style='border-bottom: solid 1px #DDDDDD; padding: 3px;'> ${reqPostula[i]['Requisito']} </td>
      <td style='border-bottom: solid 1px #DDDDDD; padding: 3px;'> ${reqPostula[i]['strObservaciones']} </td> </tr>`;
    }
    tblObserva += `</table>`;
    let contenido = this.confMensaje.bodyMensaje(1, 'na', 'na', 'na', 'na', 'na') + localStorage.getItem('localUsuarioName') +
      this.confMensaje.bodyMensaje(4, 'na', 'na', 'na', 'na', 'na') + localStorage.getItem('modNom') + ', ' + this.vecAjusteBeca[0].strMailObservaReq +
      this.confMensaje.bodyMensaje(5, 'na', 'na', 'na', 'na', 'na') + tblObserva + this.confMensaje.bodyMensaje(6, 'na', 'na', 'na', 'na', 'na');
    //mi correo   this.correoPostula
    this.srvInsert.envioMail('Postulación ' + localStorage.getItem('modNom'), this.correoPostula, btoa(contenido)).subscribe(resEnvio => {
      if (resEnvio.mensajes)
        this.alerti.success("Observaciones enviadas correctamente al correo del postulante.");
    });
  }
  //FUNCION PARA MOSTRAR U OCULTYAR EL CUADRO DE OBSERVACIONES DEL REQUISITO SUBIDO
  cambiaAcepta() {
    this.opcionObs = this.vecPostulaReq['aceptado'] == 1 ? true : false;
    this.vecPostulaReq['observacion'] = this.vecPostulaReq['aceptado'] == 1 ? '' : this.vecPostulaReq['observacion'];
  }
  cerrrarModal() {
    this.mr.close();
  }
}
